export default __webpack_public_path__ + "static/media/text.f2ee6fd5.png";